import type { LogoCarouselItem } from '../components/LogoCarousel/LogoSlide/LogoSlide';

export const supportingLogoConfig: LogoCarouselItem[] = [
  {
    id: 'arbitrum',
    title: 'Arbitrum',
    defaultLogoUrl: '/magicsquare/landing/supportingLogo/Arbitrum.png',
    hoverLogoUrl: '/magicsquare/landing/supportingLogo/ArbitrumHover.png',
  },
  {
    id: 'avalanche',
    title: 'Avalanche',
    defaultLogoUrl: '/magicsquare/landing/supportingLogo/Avalanche.png',
    hoverLogoUrl: '/magicsquare/landing/supportingLogo/AvalancheHover.png',
  },
  {
    id: 'base',
    title: 'Base',
    defaultLogoUrl: '/magicsquare/landing/supportingLogo/Base.png',
    hoverLogoUrl: '/magicsquare/landing/supportingLogo/BaseHover.png',
  },
  {
    id: 'bnb',
    title: 'BNB',
    defaultLogoUrl: '/magicsquare/landing/supportingLogo/BNB.png',
    hoverLogoUrl: '/magicsquare/landing/supportingLogo/BNBHover.png',
  },
  {
    id: 'cardano',
    title: 'Cardano',
    defaultLogoUrl: '/magicsquare/landing/supportingLogo/Cardano.png',
    hoverLogoUrl: '/magicsquare/landing/supportingLogo/CardanoHover.png',
  },
  {
    id: 'ethereum',
    title: 'Ethereum',
    defaultLogoUrl: '/magicsquare/landing/supportingLogo/Ethereum.png',
    hoverLogoUrl: '/magicsquare/landing/supportingLogo/EthereumHover.png',
  },
  {
    id: 'immutablex',
    title: 'ImmutableX',
    defaultLogoUrl: '/magicsquare/landing/supportingLogo/ImmutableX.png',
    hoverLogoUrl: '/magicsquare/landing/supportingLogo/ImmutableXHover.png',
  },
  {
    id: 'injective',
    title: 'Injective',
    defaultLogoUrl: '/magicsquare/landing/supportingLogo/Injective.png',
    hoverLogoUrl: '/magicsquare/landing/supportingLogo/InjectiveHover.png',
  },
  {
    id: 'kaia',
    title: 'KAIA',
    defaultLogoUrl: '/magicsquare/landing/supportingLogo/KAIA.png',
    hoverLogoUrl: '/magicsquare/landing/supportingLogo/KAIAHover.png',
  },
  {
    id: 'linea',
    title: 'Linea',
    defaultLogoUrl: '/magicsquare/landing/supportingLogo/Linea.png',
    hoverLogoUrl: '/magicsquare/landing/supportingLogo/LineaHover.png',
  },
  {
    id: 'mantaNetwork',
    title: 'Manta Network',
    defaultLogoUrl: '/magicsquare/landing/supportingLogo/MantaNetwork.png',
    hoverLogoUrl: '/magicsquare/landing/supportingLogo/MantaNetworkHover.png',
  },
  {
    id: 'metis',
    title: 'Metis',
    defaultLogoUrl: '/magicsquare/landing/supportingLogo/Metis.png',
    hoverLogoUrl: '/magicsquare/landing/supportingLogo/MetisHover.png',
  },
  {
    id: 'moonbeam',
    title: 'Moonbeam',
    defaultLogoUrl: '/magicsquare/landing/supportingLogo/Moonbeam.png',
    hoverLogoUrl: '/magicsquare/landing/supportingLogo/MoonbeamHover.png',
  },
  {
    id: 'multiversX',
    title: 'MultiversX',
    defaultLogoUrl: '/magicsquare/landing/supportingLogo/MultiversX.png',
    hoverLogoUrl: '/magicsquare/landing/supportingLogo/MultiversXHover.png',
  },
  {
    id: 'near',
    title: 'Near',
    defaultLogoUrl: '/magicsquare/landing/supportingLogo/NEAR.png',
    hoverLogoUrl: '/magicsquare/landing/supportingLogo/NEARHover.png',
  },
  {
    id: 'optimism',
    title: 'Optimism',
    defaultLogoUrl: '/magicsquare/landing/supportingLogo/Optimism.png',
    hoverLogoUrl: '/magicsquare/landing/supportingLogo/OptimismHover.png',
  },
  {
    id: 'polygon',
    title: 'Polygon',
    defaultLogoUrl: '/magicsquare/landing/supportingLogo/Polygon.png',
    hoverLogoUrl: '/magicsquare/landing/supportingLogo/PolygonHover.png',
  },
  {
    id: 'sei',
    title: 'Sei',
    defaultLogoUrl: '/magicsquare/landing/supportingLogo/Sei.png',
    hoverLogoUrl: '/magicsquare/landing/supportingLogo/SeiHover.png',
  },
  {
    id: 'skale',
    title: 'Skale',
    defaultLogoUrl: '/magicsquare/landing/supportingLogo/SKALE.png',
    hoverLogoUrl: '/magicsquare/landing/supportingLogo/SKALEHover.png',
  },
  {
    id: 'solana',
    title: 'Solana',
    defaultLogoUrl: '/magicsquare/landing/supportingLogo/Solana.png',
    hoverLogoUrl: '/magicsquare/landing/supportingLogo/SolanaHover.png',
  },
  {
    id: 'somnia',
    title: 'Somnia',
    defaultLogoUrl: '/magicsquare/landing/supportingLogo/Somnia.png',
    hoverLogoUrl: '/magicsquare/landing/supportingLogo/SomniaHover.png',
  },
  {
    id: 'soneium',
    title: 'Soneium',
    defaultLogoUrl: '/magicsquare/landing/supportingLogo/Soneium.png',
    hoverLogoUrl: '/magicsquare/landing/supportingLogo/SoneiumHover.png',
  },
  {
    id: 'sonic',
    title: 'Sonic',
    defaultLogoUrl: '/magicsquare/landing/supportingLogo/Sonic.png',
    hoverLogoUrl: '/magicsquare/landing/supportingLogo/SonicHover.png',
  },
  {
    id: 'ton',
    title: 'TON',
    defaultLogoUrl: '/magicsquare/landing/supportingLogo/TON.png',
    hoverLogoUrl: '/magicsquare/landing/supportingLogo/TONHover.png',
  },
];
